import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';
import React from 'react';

interface IFilterToggleButtonProps {
    siteFiltersCollapsed: boolean;
    setSiteFiltersCollapsed: (value: boolean) => void;
}

export const FilterToggleButton: React.FC<IFilterToggleButtonProps> = ({ siteFiltersCollapsed, setSiteFiltersCollapsed }) => (
    <Button
        type="text"
        icon={
            siteFiltersCollapsed ? (
                <DoubleRightOutlined style={{ color: 'white' }} />
            ) : (
                <DoubleLeftOutlined style={{ color: 'var(--ant-color-primary)' }} />
            )
        }
        style={{
            position: 'absolute',
            top: '8px',
            left: siteFiltersCollapsed ? 4 : 210,
            zIndex: 1000,
            fontSize: '16px',
        }}
        onClick={() => setSiteFiltersCollapsed(!siteFiltersCollapsed)}
    />
);
